import { render, staticRenderFns } from "./ClientTab.vue?vue&type=template&id=2bed8447&scoped=true&"
import script from "./ClientTab.vue?vue&type=script&lang=js&"
export * from "./ClientTab.vue?vue&type=script&lang=js&"
import style0 from "./ClientTab.vue?vue&type=style&index=0&id=2bed8447&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bed8447",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bed8447')) {
      api.createRecord('2bed8447', component.options)
    } else {
      api.reload('2bed8447', component.options)
    }
    module.hot.accept("./ClientTab.vue?vue&type=template&id=2bed8447&scoped=true&", function () {
      api.rerender('2bed8447', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box/components/tabs/ClientTab.vue"
export default component.exports